import React from 'react';
import Card from '@material-ui/core/Card';
import '../css/AstrophysicsPage.css';


/**
 * This function renders the AstrophysicsPage page
 * @component AstrophysicsPage
 * @return {Component} AstrophysicsPage component
 */
export default function AstrophysicsPage() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <div className="astrophysics-section">
        <h2>2022 A.I.S. Astrophysics Research Initiatives</h2>
        <p>
            Many questions remain unanswered in the field of astrophysics. The
            Advanced Intelligence Services Corporation is invested in delivering
            required next-generation solutions to the U.S. Defense Department to
            achieve superior success in space flight, exploration, and
            colonization operations into and beyond the next century.
        </p>
        <p>
            A.I.S. is working to upgrade traditional astrophysics research
            objectives with a meticulous multi-circa research development
            strategy, carefully organized to:
        </p>
        <ul>
          <li>
            <span>
                Gain a clearer understanding of our Universe through analysis of
                the precision value of historic and circa-contextual
                astrophysics data for use in next-generation experiments,
                special interest projects, and technical support functions;
            </span>
          </li>
          <li>
            <span>
                Challenge certain aspects of astrophysical data with
                state-of-the-art metabolic matter expression theories,
                next-generation information technology concepts, and accelerated
                robotic molecular print resource management system
                methodologies;
            </span>
          </li>
          <li>
            <span>
                Work with lawmakers to responsibly facilitate the initialization
                of the metabolic physics information technology marketplace in
                the United States, and promote the safe use of metabolic physics
                information technologies through early participation in
                international usage regulation programs;
            </span>
          </li>
          <li>
            <span>
                Discourage the success of any U.S. enemy, adversary, or opponent
                activity participant seeking to conduct or suggest the
                neutralization of the United States of America and it’s people
                by impacting or disturbing core asset values;
            </span>
          </li>
          <li>
            <span>
                Provide sensitive calculations, facts and opinions to military
                organization managers and improve the overall success of
                military’s space-based operations expansion applications with
                outstanding excellence in live-time, multi-circa client service
                and technology usage support programs;
            </span>
          </li>
          <li>
            <span>
                Assess the compatibility of scientific findings between
                circa-contextual astrophysical theories and the results of
                biological expression research programs, contributing to the
                success of long-term space exploration missions and off-planet
                colonization programs, such as orbital labs and long-term
                community living configurations;
            </span>
          </li>
          <li>
            <span>
                Sponsor professional networking opportunities to build
                multi-circa relationships with physicists, healthcare
                professionals, attorneys, as well as government representatives
                and their participating organizations to achieve precision
                results in the structured development of the metabolic physics
                information technology hardware marketplace in the United States
                of America; and
            </span>
          </li>
          <li>
            <span>
                Develop and introduce proprietary space-based operations
                technologies and exploration expansion programs designed to
                reduce or eliminate the liability and costs incurred to the U.S.
                Department of Defense in, and beyond these research and
                development contexts.
            </span>
          </li>
        </ul>
      </div>
      <div>
        <p>
            “The science of astrophysics conveys the revelation of the intrinsic
            qualities of God’s natural wealth, and provides insight into
            relationships between the interdependent biological substances
            spread throughout His expression. The planets, stars, and nebulae
            represent unique expressions of biology, regardless of a primary
            inhabitance of any sort. Thus, at the greatest levels of expectation
            by education, it is reasonable to propose that other Universes do
            exist, based on the immediate potential for alternate constellations
            of physics defined outside of the linear expression of our own
            Universe.” – Jim D. Ray, Jr., August 2022
        </p>
        <p></p>
      </div>
    </Card>
  );
}
